webpackJsonp([276933693913514],{

/***/ 410:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>This website was built with Gatsby.js. Thanks for your visit!</p>","frontmatter":{"title":"Welcome to My Portolio Website","date":"10 January, 2018"}}},"pathContext":{"slug":"/welcome/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---welcome-7864979db398975a3fa6.js